/** Shared social proof — home, mentorship, and program pages. */
export const TESTIMONIALS = [
  {
    id: 'practice-track-raaz',
    context: 'platform',
    quote:
      'Been using CrafterHack for a few weeks and it’s become my daily DSA habit. The Practice Track is structured without feeling overwhelming, and the editor + test cases just work. Way better than jumping between random YouTube videos and LeetCode with no plan.',
    name: 'Mohammed Raaz',
    role: 'Full-stack engineer · Storable · 4 YOE',
    outcome: 'Practice Track',
    rating: 5,
  },
  {
    id: 'contest-shoab',
    context: 'platform',
    quote:
      'Joined a live contest on CrafterHack last weekend — the timer and leaderboard actually made it feel like a real interview round. Solving under pressure here is way more useful than doing easy problems alone. Solid platform if you want to level up fast.',
    name: 'Mohammed Shoab',
    role: 'Frontend developer · Coditas · 6 YOE',
    outcome: 'Live contest',
    rating: 4.5,
  },
  {
    id: 'full-loop-aasim',
    context: 'mentorship',
    quote:
      'CrafterHack nails the full loop: problems, contests, and mock interviews in one place. I like that it’s not just another problem bank — the 75 Hard challenge and interview prep tracks keep you accountable. Clean UI, no clutter. Definitely worth checking out if you’re prepping for placements.',
    name: 'Mohd Aasim',
    role: 'Full-stack engineer · Material · 6 YOE',
    outcome: 'Interview Prep',
    rating: 5,
  },
  {
    id: 'mock-asad',
    context: 'mentorship',
    quote:
      'Booked a mock interview on CrafterHack and it felt surprisingly close to a real FAANG round — timed problem, follow-ups, and written feedback after. For the price, it’s one of the best ways I’ve found to spot gaps before the actual interview. Not just another problem site.',
    name: 'Mohd Asad',
    role: 'Frontend developer · Fresher',
    outcome: 'Mock interview',
    rating: 4,
  },
  {
    id: 'all-in-one-akshay',
    context: 'platform',
    quote:
      'What I like about CrafterHack is that everything’s in one place — problems, contests, interview prep, even pair programming. I’m not bouncing between 4 different tabs anymore. The UI is clean, signup was quick, and I actually stuck with the 75 Hard challenge longer than I expected. Good pick if you’re serious about DSA but don’t want a messy setup.',
    name: 'Akshay',
    role: 'Customer support & UX design · Airtel',
    outcome: '75 Hard Challenge',
    rating: 4.5,
  },
  {
    id: 'pair-programming-noorul',
    context: 'platform',
    quote:
      'Did a live pair programming session on CrafterHack and it changed how I approach problems — explaining your logic out loud and getting unstuck in real time beats grinding alone. The leaderboard and contests also give you a small community feel without the noise of bigger platforms. Solid if you want practice that actually feels interactive.',
    name: 'Noorul',
    role: 'Full-stack engineer · Ijona · 4 YOE',
    outcome: 'Pair programming',
    rating: 5,
  },
  {
    id: 'structured-prep-sheeraz',
    context: 'mentorship',
    quote:
      'I used to solve random LeetCode problems with no real plan. CrafterHack’s interview prep tracks and topic-wise problem sets finally gave me a path — Arrays → Trees → DP, with progress you can actually see. Felt less like “hope I’m ready” and more like “I know what’s left.” Great if placements are coming up and you need structure, not just more problems.',
    name: 'Mohammed Sheeraz',
    role: 'Business owner · 3 YOE',
    outcome: 'Interview Prep',
    rating: 4.5,
  },
];

export const filterTestimonials = (context = 'all', limit) => {
  const list =
    context === 'all'
      ? TESTIMONIALS
      : TESTIMONIALS.filter((t) => t.context === context);
  return limit ? list.slice(0, limit) : list;
};
